import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export interface StrapiGoogleReviewsSectionDTO
  extends StrapiDynamicZoneComponentDTO {
  heading: string;
  layout: "Carousel" | "Grid";
  maxItems: number;
  showAggregate: boolean;
  writeReviewCta: boolean;
  profileLink: boolean;
}

export class GoogleReviewsSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  layout: "Carousel" | "Grid";
  maxItems: number;
  showAggregate: boolean;
  writeReviewCta: boolean;
  profileLink: boolean;
}
